import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { ErrorBoundary } from '../components/shared/ErrorBoundary';
import { BodyPointerEventsGuard } from '../components/shared/BodyPointerEventsGuard';
import { NotFoundPage } from '../components/shared/NotFoundPage';
import { Loading } from '@fiado/react-kit';
import type { useAuthStore } from '../stores/authStore';

export interface AppRouterContext {
    auth: {
        ensureLoaded: () => ReturnType<ReturnType<typeof useAuthStore.getState>['ensureLoaded']>;
    };
}

const TanStackRouterDevtools = import.meta.env.PROD
    ? () => null
    : lazy(() =>
          import('@tanstack/router-devtools').then((d) => ({ default: d.TanStackRouterDevtools })),
      );

export const Route = createRootRouteWithContext<AppRouterContext>()({
    component: () => (
        <ErrorBoundary>
            <BodyPointerEventsGuard />
            <Outlet />
            <Suspense fallback={null}>
                <TanStackRouterDevtools position="bottom-right" />
            </Suspense>
        </ErrorBoundary>
    ),
    notFoundComponent: NotFoundPage,
    pendingComponent: () => <Loading size="lg" fullScreen />,
});
